var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        { staticClass: "filters", attrs: { inline: "" } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "服务商" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择服务商" },
                  on: { change: _vm.handlePlatformChange },
                  model: {
                    value: _vm.platformId,
                    callback: function ($$v) {
                      _vm.platformId = $$v
                    },
                    expression: "platformId",
                  },
                },
                _vm._l(_vm.platforms, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.platformName, value: item.id },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "授权小程序" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "300px" },
                  attrs: { filterable: "", placeholder: "请选择已授权小程序" },
                  on: { change: _vm.handleAppChange },
                  model: {
                    value: _vm.companyAppId,
                    callback: function ($$v) {
                      _vm.companyAppId = $$v
                    },
                    expression: "companyAppId",
                  },
                },
                _vm._l(_vm.apps, function (item) {
                  return _c("el-option", {
                    key: item.companyAppId,
                    attrs: {
                      label: item.appName + "（" + item.appId + "）",
                      value: item.companyAppId,
                    },
                  })
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      !_vm.companyAppId
        ? _c("el-empty", {
            attrs: { description: "请选择已授权小程序后管理发布前配置" },
          })
        : _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.handleTabClick },
              model: {
                value: _vm.activeTab,
                callback: function ($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "基本信息", name: "basic" } },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.basicInfoLoading,
                          expression: "basicInfoLoading",
                        },
                      ],
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "toolbar" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                icon: "el-icon-refresh",
                                loading: _vm.basicInfoLoading,
                              },
                              on: { click: _vm.loadBasicInfo },
                            },
                            [_vm._v("重新读取微信数据")]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "quota-tip" }, [
                            _vm._v(
                              "名称修改涉及单独的资质审核流程，本页暂不提供修改。"
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "basic-card" }, [
                        _c(
                          "div",
                          { staticClass: "head-image-panel" },
                          [
                            _vm.basicInfo.headImageInfo &&
                            _vm.basicInfo.headImageInfo.headImageUrl
                              ? _c("el-image", {
                                  staticClass: "head-image",
                                  attrs: {
                                    src: _vm.basicInfo.headImageInfo
                                      .headImageUrl,
                                    fit: "cover",
                                    "preview-src-list": [
                                      _vm.basicInfo.headImageInfo.headImageUrl,
                                    ],
                                  },
                                })
                              : _c(
                                  "div",
                                  {
                                    staticClass: "head-image empty-head-image",
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-picture-outline",
                                    }),
                                  ]
                                ),
                            _vm._v(" "),
                            _c(
                              "el-upload",
                              {
                                attrs: {
                                  action: "#",
                                  accept: ".jpg,.jpeg,.png,.bmp,.gif",
                                  "show-file-list": false,
                                  "before-upload":
                                    _vm.beforeBasicHeadImageUpload,
                                  "http-request": _vm.uploadBasicHeadImage,
                                },
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "has-permi",
                                        rawName: "v-has-permi",
                                        value: [
                                          "admin:wechat:open-platform:config",
                                        ],
                                        expression:
                                          "['admin:wechat:open-platform:config']",
                                      },
                                    ],
                                    attrs: {
                                      size: "small",
                                      loading: _vm.basicHeadImageSaving,
                                    },
                                  },
                                  [_vm._v("修改头像")]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-tip" }, [
                              _vm._v(
                                "请上传正方形图片，支持 jpg、png、bmp、gif，最大 2MB。"
                              ),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "basic-detail-grid" }, [
                          _c("div", [
                            _c("span", [_vm._v("小程序名称")]),
                            _c("strong", [
                              _vm._v(_vm._s(_vm.basicInfo.nickname || "-")),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _c("span", [_vm._v("AppID")]),
                            _c("strong", [
                              _vm._v(_vm._s(_vm.basicInfo.appId || "-")),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _c("span", [_vm._v("主体名称")]),
                            _c("strong", [
                              _vm._v(
                                _vm._s(_vm.basicInfo.principalName || "-")
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            [
                              _c("span", [_vm._v("实名状态")]),
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    size: "small",
                                    type: _vm.realnameStatusType(
                                      _vm.basicInfo.realnameStatus
                                    ),
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.realnameStatusLabel(
                                        _vm.basicInfo.realnameStatus
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", [
                            _c("span", [_vm._v("资质认证")]),
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm.basicInfo.verifyInfo &&
                                    _vm.basicInfo.verifyInfo.qualificationVerify
                                    ? "已认证"
                                    : "未认证"
                                )
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _c("span", [_vm._v("名称认证")]),
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm.basicInfo.verifyInfo &&
                                    _vm.basicInfo.verifyInfo.namingVerify
                                    ? "已认证"
                                    : "未认证"
                                )
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _c("span", [_vm._v("头像修改额度")]),
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm.quotaText(_vm.basicInfo.headImageInfo)
                                ) + "（本月）"
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _c("span", [_vm._v("简介修改额度")]),
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm.quotaText(_vm.basicInfo.signatureInfo)
                                ) + "（本月）"
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _c("span", [_vm._v("名称修改额度")]),
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm.quotaText(_vm.basicInfo.nicknameInfo)
                                ) + "（本年）"
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-divider",
                        { attrs: { "content-position": "left" } },
                        [_vm._v("功能介绍")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form",
                        {
                          staticClass: "signature-form",
                          attrs: { "label-width": "90px" },
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "功能介绍" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  rows: 3,
                                  maxlength: "120",
                                  "show-word-limit": "",
                                  placeholder: "请输入4-120个字符",
                                },
                                model: {
                                  value: _vm.basicSignature,
                                  callback: function ($$v) {
                                    _vm.basicSignature =
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                  },
                                  expression: "basicSignature",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "has-permi",
                                      rawName: "v-has-permi",
                                      value: [
                                        "admin:wechat:open-platform:config",
                                      ],
                                      expression:
                                        "['admin:wechat:open-platform:config']",
                                    },
                                  ],
                                  attrs: {
                                    type: "primary",
                                    loading: _vm.basicSignatureSaving,
                                  },
                                  on: { click: _vm.saveBasicSignature },
                                },
                                [_vm._v("保存功能介绍")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-divider",
                        { attrs: { "content-position": "left" } },
                        [_vm._v("订单中心 Path")]
                      ),
                      _vm._v(" "),
                      _c("el-alert", {
                        staticClass: "section-alert",
                        attrs: {
                          title:
                            "提交后将进入微信审核。微信通过第三方平台回调推送审核结果，也可以点击“重新读取微信数据”查询最新状态。",
                          type: "info",
                          closable: false,
                          "show-icon": "",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "el-form",
                        {
                          staticClass: "order-path-form",
                          attrs: { "label-width": "110px" },
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "订单页 Path", required: "" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder:
                                    "例如：pages/order/list（不能以 / 开头）",
                                },
                                model: {
                                  value: _vm.orderPathForm.path,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.orderPathForm,
                                      "path",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "orderPathForm.path",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "审核图片URL" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  rows: 3,
                                  placeholder:
                                    "可选，每行一个微信可访问的完整HTTP/HTTPS图片地址",
                                },
                                model: {
                                  value: _vm.orderPathForm.imageUrls,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.orderPathForm,
                                      "imageUrls",
                                      $$v
                                    )
                                  },
                                  expression: "orderPathForm.imageUrls",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "审核视频URL" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder:
                                    "可选，填写微信可访问的完整HTTP/HTTPS视频地址",
                                },
                                model: {
                                  value: _vm.orderPathForm.video,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.orderPathForm,
                                      "video",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "orderPathForm.video",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-row",
                            { attrs: { gutter: 16 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "测试账号" } },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          autocomplete: "off",
                                          placeholder: "可选",
                                        },
                                        model: {
                                          value: _vm.orderPathForm.testAccount,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.orderPathForm,
                                              "testAccount",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression:
                                            "orderPathForm.testAccount",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "测试密码" } },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          type: "password",
                                          autocomplete: "new-password",
                                          "show-password": "",
                                          placeholder: "可选",
                                        },
                                        model: {
                                          value: _vm.orderPathForm.testPassword,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.orderPathForm,
                                              "testPassword",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "orderPathForm.testPassword",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "测试备注" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  rows: 2,
                                  maxlength: "500",
                                  "show-word-limit": "",
                                  placeholder:
                                    "可选，说明审核人员如何进入订单页",
                                },
                                model: {
                                  value: _vm.orderPathForm.testRemark,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.orderPathForm,
                                      "testRemark",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "orderPathForm.testRemark",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "has-permi",
                                      rawName: "v-has-permi",
                                      value: [
                                        "admin:wechat:open-platform:config",
                                      ],
                                      expression:
                                        "['admin:wechat:open-platform:config']",
                                    },
                                  ],
                                  attrs: {
                                    type: "primary",
                                    loading: _vm.orderPathApplying,
                                  },
                                  on: { click: _vm.applyOrderPath },
                                },
                                [_vm._v("提交订单 Path 申请")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-table",
                        { attrs: { data: _vm.orderPathRows, border: "" } },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "versionLabel",
                              label: "版本",
                              width: "100",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "path",
                              label: "订单页 Path",
                              "min-width": "260",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [_vm._v(_vm._s(scope.row.path || "-"))]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "申请状态",
                              width: "120",
                              align: "center",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row.available !== false
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type: _vm.orderPathStatusType(
                                                scope.row.status
                                              ),
                                              size: "small",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.orderPathStatusLabel(
                                                    scope.row
                                                  )
                                                ) +
                                                "\n              "
                                            ),
                                          ]
                                        )
                                      : _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type: "danger",
                                              size: "small",
                                            },
                                          },
                                          [_vm._v("读取失败")]
                                        ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "applyTime",
                              label: "申请时间",
                              width: "180",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(_vm._s(scope.row.applyTime || "-")),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "error",
                              label: "说明",
                              "min-width": "220",
                              "show-overflow-tooltip": "",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                { attrs: { label: "成员管理", name: "member" } },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.memberLoading,
                          expression: "memberLoading",
                        },
                      ],
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "member-role-grid" },
                        _vm._l(_vm.memberConfig.roles || [], function (role) {
                          return _c(
                            "div",
                            { key: role.code, staticClass: "member-role-card" },
                            [
                              _c(
                                "div",
                                { staticClass: "member-role-title" },
                                [
                                  _c("strong", [_vm._v(_vm._s(role.name))]),
                                  _vm._v(" "),
                                  _c(
                                    "el-tag",
                                    {
                                      attrs: {
                                        type: role.apiSupported
                                          ? "success"
                                          : "info",
                                        size: "small",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            role.apiSupported
                                              ? "支持接口管理"
                                              : "微信侧管理"
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "member-role-description" },
                                [_vm._v(_vm._s(role.description))]
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c("el-alert", {
                        staticClass: "section-alert",
                        attrs: {
                          title:
                            "第三方平台官方接口目前只支持体验者管理；开发者和运营者请登录微信公众平台，在“人员设置”中绑定或解绑。",
                          type: "info",
                          closable: false,
                          "show-icon": "",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "tester-toolbar" },
                        [
                          _c("el-input", {
                            attrs: {
                              maxlength: "64",
                              clearable: "",
                              placeholder: "请输入要绑定的体验者微信号",
                            },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.bindTester($event)
                              },
                            },
                            model: {
                              value: _vm.testerWechatId,
                              callback: function ($$v) {
                                _vm.testerWechatId =
                                  typeof $$v === "string" ? $$v.trim() : $$v
                              },
                              expression: "testerWechatId",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "has-permi",
                                  rawName: "v-has-permi",
                                  value: ["admin:wechat:open-platform:config"],
                                  expression:
                                    "['admin:wechat:open-platform:config']",
                                },
                              ],
                              attrs: {
                                type: "primary",
                                loading: _vm.testerBinding,
                              },
                              on: { click: _vm.bindTester },
                            },
                            [_vm._v("绑定体验者")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                icon: "el-icon-refresh",
                                loading: _vm.memberLoading,
                              },
                              on: { click: _vm.loadMemberConfig },
                            },
                            [_vm._v("刷新列表")]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-tip tester-tip" }, [
                        _vm._v(
                          "\n          绑定时填写的是用户可被搜索的微信号，不是昵称、手机号或 OpenID。微信查询接口仅返回脱敏唯一标识 userstr。\n        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-table",
                        {
                          attrs: {
                            data: _vm.memberConfig.testers || [],
                            border: "",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "sequence",
                              label: "序号",
                              width: "80",
                              align: "center",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "wechatId",
                              label: "微信号",
                              "min-width": "180",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row.wechatId
                                      ? _c("span", [
                                          _vm._v(_vm._s(scope.row.wechatId)),
                                        ])
                                      : _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              content:
                                                "该体验者不是通过当前后台绑定，微信接口无法返回其微信号",
                                              placement: "top",
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "unknown-member-info",
                                              },
                                              [_vm._v("未知")]
                                            ),
                                          ]
                                        ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "userStr",
                              label: "体验者唯一标识（userstr）",
                              "min-width": "360",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "成员角色",
                              width: "120",
                              align: "center",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              size: "small",
                                              type: "success",
                                            },
                                          },
                                          [_vm._v("体验者")]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "createBy",
                              label: "绑定人",
                              "min-width": "130",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(_vm._s(scope.row.createBy || "-")),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "bindTime",
                              label: "绑定时间",
                              width: "180",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(_vm._s(scope.row.bindTime || "-")),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "操作",
                              width: "110",
                              align: "center",
                              fixed: "right",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "has-permi",
                                            rawName: "v-has-permi",
                                            value: [
                                              "admin:wechat:open-platform:config",
                                            ],
                                            expression:
                                              "['admin:wechat:open-platform:config']",
                                          },
                                        ],
                                        staticClass: "danger-text",
                                        attrs: {
                                          type: "text",
                                          loading:
                                            _vm.testerUnbindingUserStr ===
                                            scope.row.userStr,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.unbindTester(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v("解绑")]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("template", { slot: "empty" }, [
                            _c("div", { staticClass: "empty-member-list" }, [
                              _vm._v("微信侧暂无已绑定体验者"),
                            ]),
                          ]),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                { attrs: { label: "发布前检查", name: "precheck" } },
                [
                  _c(
                    "div",
                    { staticClass: "toolbar" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            icon: "el-icon-refresh",
                            loading: _vm.precheckLoading,
                          },
                          on: { click: _vm.loadPrecheck },
                        },
                        [_vm._v("重新检查")]
                      ),
                      _vm._v(" "),
                      _vm.precheck.checks
                        ? _c(
                            "el-tag",
                            {
                              attrs: {
                                type: _vm.precheck.ready ? "success" : "danger",
                              },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.precheck.ready
                                      ? "发布前检查通过"
                                      : "存在未完成项"
                                  ) +
                                  "\n        "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.precheckLoading,
                          expression: "precheckLoading",
                        },
                      ],
                      attrs: { data: _vm.precheck.checks || [], border: "" },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "name",
                          label: "检查项",
                          "min-width": "180",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "是否必需",
                          width: "100",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  _vm._s(scope.row.required ? "是" : "否")
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "状态", width: "110", align: "center" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      type: scope.row.passed
                                        ? "success"
                                        : "danger",
                                      size: "small",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          scope.row.passed ? "通过" : "未通过"
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "message",
                          label: "说明",
                          "min-width": "300",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                { attrs: { label: "域名配置", name: "domain" } },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.domainLoading,
                          expression: "domainLoading",
                        },
                      ],
                    },
                    [
                      _c("el-alert", {
                        staticClass: "section-alert",
                        attrs: {
                          title:
                            "每行填写一个完整域名。服务器域名必须先登记在第三方平台中，微信接口才允许配置到授权小程序。",
                          type: "info",
                          closable: false,
                          "show-icon": "",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "el-form",
                        {
                          staticClass: "config-form",
                          attrs: { "label-width": "155px" },
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "request合法域名" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  rows: 3,
                                  placeholder: "https://api.example.com",
                                },
                                model: {
                                  value: _vm.domainForm.requestDomains,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.domainForm,
                                      "requestDomains",
                                      $$v
                                    )
                                  },
                                  expression: "domainForm.requestDomains",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "socket合法域名" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  rows: 3,
                                  placeholder: "wss://socket.example.com",
                                },
                                model: {
                                  value: _vm.domainForm.wsRequestDomains,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.domainForm,
                                      "wsRequestDomains",
                                      $$v
                                    )
                                  },
                                  expression: "domainForm.wsRequestDomains",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "uploadFile合法域名" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  rows: 3,
                                  placeholder: "https://upload.example.com",
                                },
                                model: {
                                  value: _vm.domainForm.uploadDomains,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.domainForm,
                                      "uploadDomains",
                                      $$v
                                    )
                                  },
                                  expression: "domainForm.uploadDomains",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "downloadFile合法域名" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  rows: 3,
                                  placeholder: "https://download.example.com",
                                },
                                model: {
                                  value: _vm.domainForm.downloadDomains,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.domainForm,
                                      "downloadDomains",
                                      $$v
                                    )
                                  },
                                  expression: "domainForm.downloadDomains",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "has-permi",
                                      rawName: "v-has-permi",
                                      value: [
                                        "admin:wechat:open-platform:config",
                                      ],
                                      expression:
                                        "['admin:wechat:open-platform:config']",
                                    },
                                  ],
                                  attrs: {
                                    type: "primary",
                                    loading: _vm.serverDomainSaving,
                                  },
                                  on: { click: _vm.saveServerDomains },
                                },
                                [_vm._v("保存服务器域名")]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("el-divider"),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "业务域名" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  rows: 3,
                                  placeholder: "https://h5.example.com",
                                },
                                model: {
                                  value: _vm.domainForm.webViewDomains,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.domainForm,
                                      "webViewDomains",
                                      $$v
                                    )
                                  },
                                  expression: "domainForm.webViewDomains",
                                },
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "field-tip" }, [
                                _vm._v("仅在小程序使用 web-view 时需要配置。"),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "has-permi",
                                      rawName: "v-has-permi",
                                      value: [
                                        "admin:wechat:open-platform:config",
                                      ],
                                      expression:
                                        "['admin:wechat:open-platform:config']",
                                    },
                                  ],
                                  attrs: {
                                    type: "primary",
                                    loading: _vm.webViewDomainSaving,
                                  },
                                  on: { click: _vm.saveWebViewDomains },
                                },
                                [_vm._v("保存业务域名")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                { on: { click: _vm.loadDomain } },
                                [_vm._v("重新读取")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                { attrs: { label: "类目管理", name: "category" } },
                [
                  _c(
                    "div",
                    { staticClass: "toolbar" },
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "has-permi",
                              rawName: "v-has-permi",
                              value: ["admin:wechat:open-platform:config"],
                              expression:
                                "['admin:wechat:open-platform:config']",
                            },
                          ],
                          attrs: {
                            type: "primary",
                            disabled:
                              !_vm.categoryConfig.availableCategories ||
                              !_vm.categoryConfig.availableCategories.length,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.openCategoryDialog("add")
                            },
                          },
                        },
                        [_vm._v("添加类目")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            icon: "el-icon-refresh",
                            loading: _vm.categoryLoading,
                          },
                          on: { click: _vm.loadCategory },
                        },
                        [_vm._v("刷新")]
                      ),
                      _vm._v(" "),
                      _vm.categoryConfig.quota !== undefined
                        ? _c("span", { staticClass: "quota-tip" }, [
                            _vm._v(
                              "\n          本周期剩余修改次数：" +
                                _vm._s(_vm.categoryConfig.quota) +
                                "，最多可设置：" +
                                _vm._s(_vm.categoryConfig.categoryLimit) +
                                "\n        "
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.categoryError
                    ? _c("el-alert", {
                        staticClass: "section-alert",
                        attrs: {
                          title: _vm.categoryError,
                          type: "warning",
                          closable: false,
                          "show-icon": "",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.categoryLoading,
                          expression: "categoryLoading",
                        },
                      ],
                      attrs: {
                        data: _vm.categoryConfig.categories || [],
                        border: "",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "firstName",
                          label: "一级类目",
                          "min-width": "160",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "secondName",
                          label: "二级类目",
                          "min-width": "180",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "审核状态",
                          width: "120",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      type: _vm.categoryAuditType(
                                        scope.row.auditStatus
                                      ),
                                      size: "small",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.categoryAuditLabel(
                                            scope.row.auditStatus
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "auditReason",
                          label: "审核说明",
                          "min-width": "220",
                          "show-overflow-tooltip": "",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "操作", width: "130", fixed: "right" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      disabled: scope.row.auditStatus === 2,
                                      content:
                                        "微信仅允许修改审核未通过类目的资质",
                                      placement: "top",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "has-permi",
                                                rawName: "v-has-permi",
                                                value: [
                                                  "admin:wechat:open-platform:config",
                                                ],
                                                expression:
                                                  "['admin:wechat:open-platform:config']",
                                              },
                                            ],
                                            attrs: {
                                              type: "text",
                                              disabled:
                                                scope.row.auditStatus !== 2,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.openCategoryDialog(
                                                  "modify",
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("修改")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "has-permi",
                                        rawName: "v-has-permi",
                                        value: [
                                          "admin:wechat:open-platform:config",
                                        ],
                                        expression:
                                          "['admin:wechat:open-platform:config']",
                                      },
                                    ],
                                    staticClass: "danger-text",
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeCategory(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("删除")]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                { attrs: { label: "隐私保护指引", name: "privacy" } },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.privacyLoading,
                          expression: "privacyLoading",
                        },
                      ],
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "toolbar" },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { size: "small" },
                              on: { change: _vm.loadPrivacy },
                              model: {
                                value: _vm.privacyVersion,
                                callback: function ($$v) {
                                  _vm.privacyVersion = $$v
                                },
                                expression: "privacyVersion",
                              },
                            },
                            [
                              _c("el-radio-button", { attrs: { label: 2 } }, [
                                _vm._v("开发版"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio-button", { attrs: { label: 1 } }, [
                                _vm._v("现网版"),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.privacyConfig.codeExist !== undefined
                            ? _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type: _vm.privacyConfig.ready
                                      ? "success"
                                      : "warning",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.privacyConfig.ready
                                          ? "配置已覆盖代码检测项"
                                          : "配置不完整"
                                      ) +
                                      "\n          "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.privacyConfig.codeExist === 0
                        ? _c("el-alert", {
                            staticClass: "section-alert",
                            attrs: {
                              title:
                                "微信尚未检测到代码，上传体验版后才能得到完整的隐私信息类型。",
                              type: "info",
                              closable: false,
                              "show-icon": "",
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "detected-list" },
                        [
                          _c("span", [_vm._v("代码检测信息类型：")]),
                          _vm._v(" "),
                          _vm._l(
                            _vm.privacyConfig.privacyList || [],
                            function (item) {
                              return _c(
                                "el-tag",
                                { key: item, attrs: { size: "small" } },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.privacyKeyLabel(item)) +
                                      "\n          "
                                  ),
                                ]
                              )
                            }
                          ),
                          _vm._v(" "),
                          !_vm.privacyConfig.privacyList ||
                          !_vm.privacyConfig.privacyList.length
                            ? _c("span", [_vm._v("暂无")])
                            : _vm._e(),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form",
                        {
                          staticClass: "config-form",
                          attrs: { "label-width": "135px" },
                        },
                        [
                          _c(
                            "el-row",
                            { attrs: { gutter: 16 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "联系邮箱" } },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value:
                                            _vm.privacyForm.ownerSetting
                                              .contactEmail,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.privacyForm.ownerSetting,
                                              "contactEmail",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression:
                                            "privacyForm.ownerSetting.contactEmail",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "联系电话" } },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value:
                                            _vm.privacyForm.ownerSetting
                                              .contactPhone,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.privacyForm.ownerSetting,
                                              "contactPhone",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression:
                                            "privacyForm.ownerSetting.contactPhone",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "QQ号" } },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value:
                                            _vm.privacyForm.ownerSetting
                                              .contactQq,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.privacyForm.ownerSetting,
                                              "contactQq",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression:
                                            "privacyForm.ownerSetting.contactQq",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "微信号" } },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value:
                                            _vm.privacyForm.ownerSetting
                                              .contactWeixin,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.privacyForm.ownerSetting,
                                              "contactWeixin",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression:
                                            "privacyForm.ownerSetting.contactWeixin",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "变更通知方式" } },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          placeholder: "例如：弹窗或公告",
                                        },
                                        model: {
                                          value:
                                            _vm.privacyForm.ownerSetting
                                              .noticeMethod,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.privacyForm.ownerSetting,
                                              "noticeMethod",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression:
                                            "privacyForm.ownerSetting.noticeMethod",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "信息存储期限" } },
                                    [
                                      _c("el-input-number", {
                                        attrs: {
                                          min: 1,
                                          max: 99999,
                                          precision: 0,
                                          "controls-position": "right",
                                          placeholder: "留空使用微信默认文案",
                                        },
                                        model: {
                                          value:
                                            _vm.privacyForm.ownerSetting
                                              .storeExpireDays,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.privacyForm.ownerSetting,
                                              "storeExpireDays",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "privacyForm.ownerSetting.storeExpireDays",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "field-suffix" },
                                        [_vm._v("天")]
                                      ),
                                      _vm._v(" "),
                                      _vm.privacyForm.ownerSetting
                                        .storeExpireDays !== null
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: { type: "text" },
                                              on: {
                                                click: function ($event) {
                                                  _vm.privacyForm.ownerSetting.storeExpireDays =
                                                    null
                                                },
                                              },
                                            },
                                            [_vm._v("使用默认期限")]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    [
                                      _c(
                                        "span",
                                        {
                                          attrs: { slot: "label" },
                                          slot: "label",
                                        },
                                        [
                                          _vm._v(
                                            "\n                  自定义隐私文件\n                  "
                                          ),
                                          _c(
                                            "el-tooltip",
                                            {
                                              attrs: {
                                                content:
                                                  "仅在不使用微信标准隐私保护指引模板时填写；它是上传自定义隐私文本文件后微信返回的 MediaId。",
                                                placement: "top",
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-question",
                                              }),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("el-input", {
                                        attrs: {
                                          placeholder:
                                            "可选；使用微信标准模板时请留空",
                                        },
                                        model: {
                                          value:
                                            _vm.privacyForm.ownerSetting
                                              .extFileMediaId,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.privacyForm.ownerSetting,
                                              "extFileMediaId",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression:
                                            "privacyForm.ownerSetting.extFileMediaId",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "form-tip" }, [
                                        _vm._v(
                                          "绝大多数小程序使用微信标准模板，此项留空即可。"
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-divider",
                            { attrs: { "content-position": "left" } },
                            [_vm._v("收集的用户信息")]
                          ),
                          _vm._v(" "),
                          _vm._l(
                            _vm.privacyForm.settings,
                            function (item, index) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  staticClass: "privacy-setting-row",
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        filterable: "",
                                        "allow-create": "",
                                        "default-first-option": "",
                                        placeholder: "请选择收集的信息类型",
                                      },
                                      model: {
                                        value: item.privacyKey,
                                        callback: function ($$v) {
                                          _vm.$set(item, "privacyKey", $$v)
                                        },
                                        expression: "item.privacyKey",
                                      },
                                    },
                                    _vm._l(
                                      _vm.privacyKeyOptions,
                                      function (option) {
                                        return _c("el-option", {
                                          key: option.key,
                                          attrs: {
                                            label:
                                              option.label +
                                              "（" +
                                              option.key +
                                              "）",
                                            value: option.key,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("el-input", {
                                    attrs: {
                                      placeholder:
                                        "收集用途，不需要填写“为了”或“用于”",
                                    },
                                    model: {
                                      value: item.privacyText,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          item,
                                          "privacyText",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "item.privacyText",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "danger-text",
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.privacyForm.settings.splice(
                                            index,
                                            1
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("删除")]
                                  ),
                                ],
                                1
                              )
                            }
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                { on: { click: _vm.addPrivacySetting } },
                                [_vm._v("添加信息类型")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "has-permi",
                                      rawName: "v-has-permi",
                                      value: [
                                        "admin:wechat:open-platform:config",
                                      ],
                                      expression:
                                        "['admin:wechat:open-platform:config']",
                                    },
                                  ],
                                  attrs: {
                                    type: "primary",
                                    loading: _vm.privacySaving,
                                  },
                                  on: { click: _vm.savePrivacy },
                                },
                                [_vm._v("保存隐私保护指引")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                { on: { click: _vm.loadPrivacy } },
                                [_vm._v("重新读取")]
                              ),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                { attrs: { label: "普通二维码", name: "qrcode" } },
                [
                  _c(
                    "div",
                    { staticClass: "toolbar" },
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "has-permi",
                              rawName: "v-has-permi",
                              value: ["admin:wechat:open-platform:config"],
                              expression:
                                "['admin:wechat:open-platform:config']",
                            },
                          ],
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.openQrcodeDialog()
                            },
                          },
                        },
                        [_vm._v("新增二维码规则")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            icon: "el-icon-refresh",
                            loading: _vm.qrcodeLoading,
                          },
                          on: { click: _vm.loadQrcodeRules },
                        },
                        [_vm._v("刷新")]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "quota-tip" }, [
                        _vm._v(
                          "本月剩余发布次数：" +
                            _vm._s(
                              _vm.qrcodeConfig.publishQuota === null ||
                                _vm.qrcodeConfig.publishQuota === undefined
                                ? "-"
                                : _vm.qrcodeConfig.publishQuota
                            )
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-alert", {
                    staticClass: "section-alert",
                    attrs: {
                      title:
                        "规则保存后处于未发布状态；测试链接可先验证跳转，确认无误后再发布。已发布规则不能修改。",
                      type: "info",
                      closable: false,
                      "show-icon": "",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.qrcodeLoading,
                          expression: "qrcodeLoading",
                        },
                      ],
                      attrs: { data: _vm.qrcodeConfig.rules || [], border: "" },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "prefix",
                          label: "二维码规则前缀",
                          "min-width": "280",
                          "show-overflow-tooltip": "",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "path",
                          label: "小程序页面",
                          "min-width": "220",
                          "show-overflow-tooltip": "",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "打开版本",
                          width: "100",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  _vm._s(
                                    _vm.qrcodeOpenVersionLabel(
                                      scope.row.openVersion
                                    )
                                  )
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "状态", width: "100", align: "center" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      type:
                                        scope.row.state === 2
                                          ? "success"
                                          : "warning",
                                      size: "small",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          scope.row.state === 2
                                            ? "已发布"
                                            : "未发布"
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "测试链接", "min-width": "220" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  _vm._s(
                                    (scope.row.debugUrls || []).join("；") ||
                                      "-"
                                  )
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "操作", width: "190", fixed: "right" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "has-permi",
                                        rawName: "v-has-permi",
                                        value: [
                                          "admin:wechat:open-platform:config",
                                        ],
                                        expression:
                                          "['admin:wechat:open-platform:config']",
                                      },
                                    ],
                                    attrs: {
                                      type: "text",
                                      disabled: scope.row.state === 2,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openQrcodeDialog(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("修改")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "has-permi",
                                        rawName: "v-has-permi",
                                        value: [
                                          "admin:wechat:open-platform:config",
                                        ],
                                        expression:
                                          "['admin:wechat:open-platform:config']",
                                      },
                                    ],
                                    attrs: {
                                      type: "text",
                                      disabled: scope.row.state === 2,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.publishQrcodeRule(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("发布")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "has-permi",
                                        rawName: "v-has-permi",
                                        value: [
                                          "admin:wechat:open-platform:config",
                                        ],
                                        expression:
                                          "['admin:wechat:open-platform:config']",
                                      },
                                    ],
                                    staticClass: "danger-text",
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeQrcodeRule(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("删除")]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                { attrs: { label: "地理位置接口", name: "location" } },
                [
                  _c(
                    "div",
                    { staticClass: "toolbar" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            icon: "el-icon-refresh",
                            loading: _vm.locationLoading,
                          },
                          on: { click: _vm.loadLocationInterfaces },
                        },
                        [_vm._v("刷新")]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "quota-tip" }, [
                        _vm._v(
                          "申请时必须提供与实际使用场景相关的网页、图片或视频材料。"
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.locationLoading,
                          expression: "locationLoading",
                        },
                      ],
                      attrs: {
                        data: _vm.locationConfig.interfaces || [],
                        border: "",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "apiChName",
                          label: "接口",
                          "min-width": "210",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("div", [
                                  _vm._v(_vm._s(scope.row.apiChName || "-")),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "form-tip" }, [
                                  _vm._v(_vm._s(scope.row.apiName)),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "apiDesc",
                          label: "用途",
                          "min-width": "300",
                          "show-overflow-tooltip": "",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "状态", width: "110", align: "center" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      type: _vm.locationStatusType(
                                        scope.row.status
                                      ),
                                      size: "small",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.locationStatusLabel(
                                            scope.row.status
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "auditId",
                          label: "审核单号",
                          width: "130",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [_vm._v(_vm._s(scope.row.auditId || "-"))]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "applyTime",
                          label: "申请时间",
                          width: "180",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(_vm._s(scope.row.applyTime || "-")),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "failReason",
                          label: "审核说明",
                          "min-width": "220",
                          "show-overflow-tooltip": "",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "操作", width: "100", fixed: "right" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "has-permi",
                                        rawName: "v-has-permi",
                                        value: [
                                          "admin:wechat:open-platform:config",
                                        ],
                                        expression:
                                          "['admin:wechat:open-platform:config']",
                                      },
                                    ],
                                    attrs: {
                                      type: "text",
                                      disabled:
                                        scope.row.status === 2 ||
                                        scope.row.status === 3 ||
                                        scope.row.status === 5,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openLocationDialog(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("申请")]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                { attrs: { label: "违规与申诉", name: "violation" } },
                [
                  _c(
                    "div",
                    { staticClass: "toolbar violation-toolbar" },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "daterange",
                          "value-format": "timestamp",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                          "picker-options": _vm.illegalDatePickerOptions,
                        },
                        model: {
                          value: _vm.illegalDateRange,
                          callback: function ($$v) {
                            _vm.illegalDateRange = $$v
                          },
                          expression: "illegalDateRange",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            loading: _vm.illegalLoading,
                          },
                          on: { click: _vm.loadIllegalRecords },
                        },
                        [_vm._v("查询")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              _vm.illegalDateRange = []
                            },
                          },
                        },
                        [_vm._v("清空时间")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-alert", {
                    staticClass: "section-alert",
                    attrs: {
                      title:
                        "默认查询最近90天。查询违规记录需权限集76；由服务商提交申诉还需权限集198。",
                      type: "info",
                      closable: false,
                      "show-icon": "",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.illegalLoading,
                          expression: "illegalLoading",
                        },
                      ],
                      attrs: {
                        data: _vm.illegalConfig.records || [],
                        border: "",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "illegalRecordId",
                          label: "违规记录ID",
                          width: "150",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "createTime",
                          label: "处罚时间",
                          width: "180",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "illegalReason",
                          label: "违规原因",
                          "min-width": "200",
                          "show-overflow-tooltip": "",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "illegalContent",
                          label: "违规内容",
                          "min-width": "240",
                          "show-overflow-tooltip": "",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "ruleName",
                          label: "规则",
                          "min-width": "180",
                          "show-overflow-tooltip": "",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "参考链接",
                          width: "100",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.caseUrl || scope.row.ruleUrl
                                  ? _c(
                                      "el-link",
                                      {
                                        attrs: {
                                          href:
                                            scope.row.caseUrl ||
                                            scope.row.ruleUrl,
                                          target: "_blank",
                                          type: "primary",
                                        },
                                      },
                                      [_vm._v("查看")]
                                    )
                                  : _c("span", [_vm._v("-")]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "操作", width: "150", fixed: "right" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openAppealRecords(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("申诉记录")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "has-permi",
                                        rawName: "v-has-permi",
                                        value: [
                                          "admin:wechat:open-platform:config",
                                        ],
                                        expression:
                                          "['admin:wechat:open-platform:config']",
                                      },
                                    ],
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openAppealDialog(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("发起申诉")]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.qrcodeForm.isEdit ? "修改二维码规则" : "新增二维码规则",
            visible: _vm.qrcodeDialogVisible,
            width: "720px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.qrcodeDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "130px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "二维码规则前缀", required: "" } },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.qrcodeForm.isEdit === 1,
                      placeholder: "https://example.com/path",
                    },
                    model: {
                      value: _vm.qrcodeForm.prefix,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.qrcodeForm,
                          "prefix",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "qrcodeForm.prefix",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "小程序页面", required: "" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "pages/index/index" },
                    model: {
                      value: _vm.qrcodeForm.path,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.qrcodeForm,
                          "path",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "qrcodeForm.path",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "打开版本", required: "" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.qrcodeForm.openVersion,
                        callback: function ($$v) {
                          _vm.$set(_vm.qrcodeForm, "openVersion", $$v)
                        },
                        expression: "qrcodeForm.openVersion",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("开发版"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v("体验版"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 3 } }, [
                        _vm._v("正式版"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "子规则匹配", required: "" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.qrcodeForm.permitSubRule,
                        callback: function ($$v) {
                          _vm.$set(_vm.qrcodeForm, "permitSubRule", $$v)
                        },
                        expression: "qrcodeForm.permitSubRule",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("不占用所有子规则"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v("占用所有子规则"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "测试链接" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 4,
                      placeholder:
                        "每行一个完整链接，最多5个，且必须符合规则前缀",
                    },
                    model: {
                      value: _vm.qrcodeForm.debugUrls,
                      callback: function ($$v) {
                        _vm.$set(_vm.qrcodeForm, "debugUrls", $$v)
                      },
                      expression: "qrcodeForm.debugUrls",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.qrcodeDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.qrcodeSaving },
                  on: { click: _vm.saveQrcodeRule },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "申请地理位置接口",
            visible: _vm.locationDialogVisible,
            width: "760px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.locationDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "110px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "接口" } },
                [
                  _c("el-input", {
                    attrs: {
                      value:
                        (_vm.locationForm.apiChName || "") +
                        "（" +
                        (_vm.locationForm.apiName || "") +
                        "）",
                      disabled: "",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "申请原因", required: "" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 4,
                      maxlength: "300",
                      "show-word-limit": "",
                      placeholder: "说明小程序中实际使用该接口的场景",
                    },
                    model: {
                      value: _vm.locationForm.content,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.locationForm,
                          "content",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "locationForm.content",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "辅助网页" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 2,
                      placeholder: "每行一个完整HTTP/HTTPS地址",
                    },
                    model: {
                      value: _vm.locationForm.urlList,
                      callback: function ($$v) {
                        _vm.$set(_vm.locationForm, "urlList", $$v)
                      },
                      expression: "locationForm.urlList",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "辅助图片" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      placeholder: "每行一个可公开访问的图片地址，最多10个",
                    },
                    model: {
                      value: _vm.locationForm.picList,
                      callback: function ($$v) {
                        _vm.$set(_vm.locationForm, "picList", $$v)
                      },
                      expression: "locationForm.picList",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "辅助视频" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 2,
                      placeholder: "填写一个可公开访问的MP4视频地址",
                    },
                    model: {
                      value: _vm.locationForm.videoList,
                      callback: function ($$v) {
                        _vm.$set(_vm.locationForm, "videoList", $$v)
                      },
                      expression: "locationForm.videoList",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.locationDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.locationApplying },
                  on: { click: _vm.applyLocationInterface },
                },
                [_vm._v("提交申请")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "违规申诉记录",
            visible: _vm.appealRecordsVisible,
            width: "900px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.appealRecordsVisible = $event
            },
          },
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.appealRecordsLoading,
                  expression: "appealRecordsLoading",
                },
              ],
              attrs: { data: _vm.appealRecords, border: "" },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "appealRecordId",
                  label: "申诉单ID",
                  width: "130",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "appealTime", label: "申诉时间", width: "180" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "来源", width: "90", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          _vm._s(scope.row.appealFrom === 1 ? "服务商" : "用户")
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "状态", width: "110", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.appealStatusType(
                                scope.row.appealStatus
                              ),
                              size: "small",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.appealStatusLabel(scope.row.appealStatus)
                              )
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "punishDescription",
                  label: "处罚说明",
                  "min-width": "180",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "auditReason",
                  label: "审核结果",
                  "min-width": "200",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "发起违规申诉",
            visible: _vm.appealDialogVisible,
            width: "860px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.appealDialogVisible = $event
            },
          },
        },
        [
          _c("el-alert", {
            staticClass: "section-alert",
            attrs: {
              title:
                "申诉材料行数必须与微信违规记录中的违规材料数量逐项对应；提交成功会消耗一次申诉次数。",
              type: "warning",
              closable: false,
              "show-icon": "",
            },
          }),
          _vm._v(" "),
          _vm._l(_vm.appealForm.appealMaterials, function (item, index) {
            return _c(
              "div",
              { key: index, staticClass: "appeal-material-card" },
              [
                _c(
                  "div",
                  { staticClass: "audit-item-header" },
                  [
                    _c("strong", [_vm._v("申诉材料 " + _vm._s(index + 1))]),
                    _vm._v(" "),
                    _vm.appealForm.appealMaterials.length > 1
                      ? _c(
                          "el-button",
                          {
                            staticClass: "danger-text",
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.appealForm.appealMaterials.splice(
                                  index,
                                  1
                                )
                              },
                            },
                          },
                          [_vm._v("删除")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("el-input", {
                  attrs: {
                    type: "textarea",
                    rows: 3,
                    maxlength: "1000",
                    "show-word-limit": "",
                    placeholder: "填写本条违规材料的申诉理由",
                  },
                  model: {
                    value: item.reason,
                    callback: function ($$v) {
                      _vm.$set(
                        item,
                        "reason",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "item.reason",
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "appeal-upload-row" },
                  [
                    _c(
                      "el-upload",
                      {
                        attrs: {
                          action: "#",
                          accept: ".jpg,.jpeg,.png,.bmp,.gif",
                          "show-file-list": false,
                          "before-upload": _vm.beforeAppealMediaUpload,
                          "http-request": function (options) {
                            return _vm.uploadAppealMaterial(options, index)
                          },
                        },
                      },
                      [
                        _c(
                          "el-button",
                          { attrs: { size: "small", loading: item.uploading } },
                          [_vm._v("上传证明图片")]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "form-tip" }, [
                      _vm._v(
                        "图片上传后得到微信临时 MediaId，请上传后及时提交申诉。"
                      ),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "appeal-media-list" },
                  _vm._l(item.proofMaterialIds, function (mediaId, mediaIndex) {
                    return _c(
                      "el-tag",
                      {
                        key: mediaId,
                        attrs: { closable: "" },
                        on: {
                          close: function ($event) {
                            return item.proofMaterialIds.splice(mediaIndex, 1)
                          },
                        },
                      },
                      [_vm._v(_vm._s(mediaId))]
                    )
                  }),
                  1
                ),
              ],
              1
            )
          }),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "text", icon: "el-icon-plus" },
              on: { click: _vm.addAppealMaterial },
            },
            [_vm._v("添加一条申诉材料")]
          ),
          _vm._v(" "),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.appealDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.appealSubmitting },
                  on: { click: _vm.submitAppeal },
                },
                [_vm._v("提交申诉")]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title:
              _vm.categoryDialogMode === "add"
                ? "添加小程序类目"
                : "修改小程序类目",
            visible: _vm.categoryDialogVisible,
            width: "820px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.categoryDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "100px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "选择类目", required: "" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        filterable: "",
                        disabled: _vm.categoryDialogMode === "modify",
                      },
                      on: { change: _vm.handleCategorySelectionChange },
                      model: {
                        value: _vm.categoryForm.categoryKey,
                        callback: function ($$v) {
                          _vm.$set(_vm.categoryForm, "categoryKey", $$v)
                        },
                        expression: "categoryForm.categoryKey",
                      },
                    },
                    _vm._l(
                      _vm.categoryConfig.availableCategories || [],
                      function (item) {
                        return _c("el-option", {
                          key: item.firstId + ":" + item.secondId,
                          attrs: {
                            label:
                              item.firstName +
                              " / " +
                              item.secondName +
                              (item.sensitiveType === 1 ? "（需资质）" : ""),
                            value: item.firstId + ":" + item.secondId,
                          },
                        })
                      }
                    ),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.selectedCategory
                ? [
                    _vm.selectedCategory.sensitiveType !== 1
                      ? _c("el-alert", {
                          attrs: {
                            title: "该类目是普通类目，无需提交资质材料。",
                            type: "success",
                            closable: false,
                            "show-icon": "",
                          },
                        })
                      : _c(
                          "div",
                          { staticClass: "qualification-panel" },
                          [
                            _c("el-alert", {
                              attrs: {
                                title:
                                  "该类目属于敏感类目。多个资质方案之间任选一个；同一方案内的材料必须全部上传。",
                                type: "warning",
                                closable: false,
                                "show-icon": "",
                              },
                            }),
                            _vm._v(" "),
                            _vm.selectedCategory.qualificationRemark
                              ? _c(
                                  "div",
                                  { staticClass: "qualification-remark" },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.selectedCategory
                                            .qualificationRemark
                                        ) +
                                        "\n          "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.qualificationGroups.length > 1
                              ? _c(
                                  "el-form-item",
                                  {
                                    attrs: { label: "资质方案", required: "" },
                                  },
                                  [
                                    _c(
                                      "el-radio-group",
                                      {
                                        on: {
                                          change: _vm.applyQualificationGroup,
                                        },
                                        model: {
                                          value:
                                            _vm.categoryForm
                                              .qualificationGroupIndex,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.categoryForm,
                                              "qualificationGroupIndex",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "categoryForm.qualificationGroupIndex",
                                        },
                                      },
                                      _vm._l(
                                        _vm.qualificationGroups,
                                        function (group, index) {
                                          return _c(
                                            "el-radio-button",
                                            {
                                              key: group.index,
                                              attrs: { label: group.index },
                                            },
                                            [
                                              _vm._v(
                                                "\n                方案" +
                                                  _vm._s(index + 1) +
                                                  "\n              "
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.qualificationGroups.length
                              ? _c(
                                  "el-form-item",
                                  {
                                    attrs: { label: "资质材料", required: "" },
                                  },
                                  [
                                    _vm._l(
                                      _vm.categoryForm.certificates,
                                      function (item, index) {
                                        return _c(
                                          "div",
                                          {
                                            key: item.key,
                                            staticClass: "certificate-card",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "certificate-name",
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(_vm._s(item.key)),
                                                ]),
                                                _vm._v(" "),
                                                item.exampleUrl
                                                  ? _c(
                                                      "el-link",
                                                      {
                                                        attrs: {
                                                          href: item.exampleUrl,
                                                          target: "_blank",
                                                          type: "primary",
                                                        },
                                                      },
                                                      [_vm._v("查看微信示例")]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "certificate-upload",
                                              },
                                              [
                                                _c(
                                                  "el-upload",
                                                  {
                                                    attrs: {
                                                      action: "#",
                                                      "show-file-list": false,
                                                      "before-upload":
                                                        _vm.beforeCategoryCertificateUpload,
                                                      "http-request": function (
                                                        options
                                                      ) {
                                                        return _vm.uploadCategoryCertificate(
                                                          options,
                                                          index
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "el-button",
                                                      {
                                                        attrs: {
                                                          size: "small",
                                                          loading:
                                                            item.uploading,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                    " +
                                                            _vm._s(
                                                              item.value
                                                                ? "重新上传"
                                                                : "上传资质图片"
                                                            ) +
                                                            "\n                  "
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                item.value
                                                  ? _c(
                                                      "el-input",
                                                      {
                                                        attrs: {
                                                          readonly: "",
                                                          size: "small",
                                                        },
                                                        model: {
                                                          value: item.value,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "value",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.value",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "template",
                                                          { slot: "prepend" },
                                                          [_vm._v("MediaId")]
                                                        ),
                                                      ],
                                                      2
                                                    )
                                                  : _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "certificate-pending",
                                                      },
                                                      [_vm._v("尚未上传")]
                                                    ),
                                              ],
                                              1
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "field-tip" }, [
                                      _vm._v(
                                        "支持 jpg、jpeg、png、bmp、gif，单张不超过 2MB；MediaId 是微信临时素材，请上传后及时提交类目。"
                                      ),
                                    ]),
                                  ],
                                  2
                                )
                              : _c(
                                  "el-form-item",
                                  {
                                    attrs: { label: "资质材料", required: "" },
                                  },
                                  [
                                    _c("el-alert", {
                                      attrs: {
                                        title:
                                          "微信未返回结构化资质清单，请刷新类目后重试，或在微信公众平台手工配置该敏感类目。",
                                        type: "error",
                                        closable: false,
                                        "show-icon": "",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                          ],
                          1
                        ),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.categoryDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.categorySaving },
                  on: { click: _vm.saveCategory },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }